<section>
  @if (
    reportsCategoryBreakdownUniversity || reportsStudentsFundedPerUniversity
  ) {
    <h2 class="heading">Per University:</h2>
  }
  <mat-divider />
</section>
@if (reportsCategoryBreakdownUniversity) {
  <app-reports-fund-allocation-per-university
    [reportsCategoryBreakdownUniversity]="
      reportsCategoryBreakdownUniversity
        ? reportsCategoryBreakdownUniversity
        : defaultReportsCategoryBreakdownUniversity
    "
  ></app-reports-fund-allocation-per-university>
}
@if (reportsStudentsFundedPerUniversity.activeStudents.length > 0) {
  <app-reports-students-funded-per-university
    [reportsStudentsFundedPerUniversity]="
      reportsStudentsFundedPerUniversity
        ? reportsStudentsFundedPerUniversity
        : []
    "
  ></app-reports-students-funded-per-university>
}
@if (reportsRacesFundedPerUniversity.activeRaces.length > 0) {
  <app-reports-races-funded-per-university
    [reportsRacesFundedPerUniversity]="
      reportsRacesFundedPerUniversity ? reportsRacesFundedPerUniversity : []
    "
  ></app-reports-races-funded-per-university>
}
